/**
 * Component to collect name and other values from the donator of an event donation
 */
import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Donation} from "../donation/donation";

@Component({
    selector: 'donator',
    templateUrl: './donator.component.html',
    providers: []
})
export class DonatorComponent implements OnInit {
    /**
     * current form for validation
     *
     * @type {FormGroup}
     */
    @Input() form: FormGroup = null;

    /**
     * current donation
     *
     * @type {Donation}
     */
    @Input() donation: Donation = null;

    /**
     * Initialize the slider
     */
    public ngOnInit(): any {
        this.form.addControl('eventData.showDonation', new FormControl(''));
        this.form.addControl('eventData.name', new FormControl('', [Validators.required]));
        this.form.addControl('eventData.message', new FormControl(''));

        // initially diasable name and message because they are not visible on init
        if (this.donation.donatorData.showDonation !== true) {
          (<FormControl>this.form.controls['eventData.name']).disable({onlySelf: true});
          (<FormControl>this.form.controls['eventData.message']).disable({onlySelf: true});
        }
    }

    /**
     * Toggle the showDonation checkbox and (de)activate validators
     */
    toggleShowDonation(): void {
        this.donation.donatorData.showDonation = !this.donation.donatorData.showDonation;

        // only validate name and message if the checkobox is activated (remark: we have the old value of the checkbox here)
        if (this.donation.donatorData.showDonation === true) {
            (<FormControl>this.form.controls['eventData.name']).enable();
            (<FormControl>this.form.controls['eventData.message']).enable();
        }
        else {
            (<FormControl>this.form.controls['eventData.name']).disable();
            (<FormControl>this.form.controls['eventData.message']).disable();
        }
    }
}
